export default class CookiesView {
  constructor() {
    this.eventHandlers = {};
  }

  async render() {
    return `
      <div id="page-cookies" class="page-content active">
        <div class="policy-page">
          <div class="policy-header">
            <h2 id="cookies-title"></h2>
            <p class="policy-date" id="cookies-date"></p>
          </div>

          <div class="policy-content" id="cookies-content">
          </div>

          <div class="back-action">
            <button type="button" id="cookies-back-btn" class="post-submit" data-text_tip="Kembali ke halaman sebelumnya" data-hover_tip="bottom" data-dev_tip="desktop" aria-label="Kembali ke halaman sebelumnya">
              <span class="material-symbols-rounded" aria-hidden="true">arrow_back</span>
              <span>Kembali</span>
            </button>
          </div>
        </div>
      </div>
    `;
  }

  async afterRender() {
    // Setup handled by presenter
  }

  renderPageHeader(pageData) {
    const titleElement = this.getTitleElement();
    const dateElement = this.getDateElement();
    
    if (titleElement) {
      titleElement.textContent = pageData.title;
    }
    
    if (dateElement) {
      dateElement.textContent = `Terakhir diperbarui: ${pageData.lastUpdated}`;
    }
  }

  renderContent(policyContent) {
    const contentContainer = this.getContentContainer();
    if (!contentContainer) return;

    let contentHtml = '';
    
    policyContent.sections.forEach(section => {
      contentHtml += `<section>`;
      contentHtml += `<h3>${this.escapeHtml(section.title)}</h3>`;
      
      if (section.content) {
        contentHtml += `<p>${this.escapeHtml(section.content)}</p>`;
      }
      
      if (section.list) {
        contentHtml += `<ul>`;
        section.list.forEach(item => {
          const [label, description] = item.split(':');
          if (description) {
            contentHtml += `<li><strong>${this.escapeHtml(label.trim())}:</strong> ${this.escapeHtml(description.trim())}</li>`;
          } else {
            contentHtml += `<li>${this.escapeHtml(item)}</li>`;
          }
        });
        contentHtml += `</ul>`;
      }
      
      if (section.subsections) {
        section.subsections.forEach(subsection => {
          contentHtml += `<h4>${this.escapeHtml(subsection.title)}</h4>`;
          if (subsection.content) {
            contentHtml += `<p>${this.escapeHtml(subsection.content)}</p>`;
          }
          if (subsection.list) {
            contentHtml += `<ul>`;
            subsection.list.forEach(item => {
              const [label, description] = item.split(':');
              if (description) {
                contentHtml += `<li><strong>${this.escapeHtml(label.trim())}:</strong> ${this.escapeHtml(description.trim())}</li>`;
              } else {
                contentHtml += `<li>${this.escapeHtml(item)}</li>`;
              }
            });
            contentHtml += `</ul>`;
          }
        });
      }
      
      if (section.note) {
        contentHtml += `<p><strong>Catatan:</strong> ${this.escapeHtml(section.note)}</p>`;
      }
      
      if (section.contact) {
        contentHtml += `
          <div class="contact-info">
            <p><strong>Email:</strong> ${this.escapeHtml(section.contact.email)}</p>
            <p><strong>Nama:</strong> ${this.escapeHtml(section.contact.name)}</p>
          </div>
        `;
      }
      
      contentHtml += `</section>`;
    });

    contentContainer.innerHTML = contentHtml;
  }

  setupBackButtonEventListener(onBackClick) {
    const backButton = this.getBackButton();
    if (backButton) {
      this.eventHandlers.backHandler = onBackClick;
      backButton.addEventListener('click', this.eventHandlers.backHandler);
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Helper methods untuk DOM queries
  getTitleElement() {
    return document.querySelector('#cookies-title');
  }

  getDateElement() {
    return document.querySelector('#cookies-date');
  }

  getContentContainer() {
    return document.querySelector('#cookies-content');
  }

  getBackButton() {
    return document.querySelector('#cookies-back-btn');
  }

  cleanupEventListeners() {
    const backButton = this.getBackButton();
    if (backButton && this.eventHandlers.backHandler) {
      backButton.removeEventListener('click', this.eventHandlers.backHandler);
    }

    this.eventHandlers = {};
  }

  cleanup() {
    this.cleanupEventListeners();
  }
}